import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const AuthErrorModal = ({ isVisible, onCancel, onTryAgain, message }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleTryAgain = () => {
    onTryAgain();
  }

  const handleCancel = () => {
    onCancel();
  }

  return (
    <Dialog
      open={isVisible}
      onClose={handleTryAgain}
      fullScreen={fullScreen}
      scroll="paper"
      maxWidth={'sm'}
    >
      <DialogTitle id="scroll-dialog-title" onClose={onTryAgain}>
        ERROR
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="error">
          {message}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleTryAgain}>Try Again</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthErrorModal;
